module.exports = __webpack_public_path__ + "static/media/phoneVerification.cb23fd6f.png";